import React from 'react';
import {changeGoldColor} from "./actions";
import {connect} from "react-redux";
import {GOLD} from "../../constants";

class GoldToggle extends React.Component {

    render() {
        let id = 'radio-' + this.props.color.description;

        return (
            <>
                <input
                    checked={this.props.isActive}
                    id={id}
                    type="radio"
                    name="Gold color"
                    value={this.props.color.description}
                    onChange={(e) => this.props.onChange(this.props.color)}
                />
                <label htmlFor={id} className="product__swatch">
                    {this.props.color.description}
                </label>
            </>
        )
    }
}



class GoldColorSelector extends React.Component {
    render() {
        return (
            <div className='product__options'>
                <div className="product__swatch-container">
                    <GoldToggle isActive={this.props.selectedColor === GOLD.YG} color={GOLD.YG} onChange={this.props.onChange}/>
                    <GoldToggle isActive={this.props.selectedColor === GOLD.WG} color={GOLD.WG} onChange={this.props.onChange}/>
                    <GoldToggle isActive={this.props.selectedColor === GOLD.RG} color={GOLD.RG} onChange={this.props.onChange}/>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        selectedColor: state.goldColor,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onChange: (color) => {
            dispatch(changeGoldColor(color));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(GoldColorSelector);
